/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

export interface NavigationContextValue {
  pathname: string;
}

const NavigationContext = createContext<NavigationContextValue | null>(null);

/** Mirrors React Router location for consumers that prefer context over `useLocation` (e.g. nav chrome). */
export function NavigationProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const value = useMemo(() => ({ pathname }), [pathname]);
  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
}

export function useNavigationContext(): NavigationContextValue {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('useNavigationContext must be used within NavigationProvider');
  }
  return ctx;
}
